<div class="msg-container"
     [class.msg-container-md]="size === 'md'"
     [class.font-md]="size === 'md'"
     [class.no-icon]="!showIcon"
     [class.text-primary]="type === MSG_TYPES.INFO || type === MSG_TYPES.SUCCESS"
     [class.text-color-default]="type === MSG_TYPES.DEFAULT"
     [class.text-danger]="type === MSG_TYPES.ERROR">
  <div class="icon-container" *ngIf="showIcon">
    <i class="{{ICONS_MAP[type]}}"></i>
  </div>
  <span class="fw-bold"
        *ngIf="title">{{ title }} </span>
  <ng-content></ng-content>
</div>
